import { createSelector } from '@ngrx/store';
import { DeliveryDetailsState } from '../reducers/delivery-details.reducer';
import { getOrderCheckoutState, OrderCheckoutState } from '../reducers/index';

const getDeliveryDetailsState = createSelector(
  getOrderCheckoutState,
  (state: OrderCheckoutState) => state.deliveryDetails,
);

export const getDeliveryDetailsError = createSelector(
  getDeliveryDetailsState,
  (state: DeliveryDetailsState) => state.error,
);

export const getDeliveryDetailsLoading = createSelector(
  getDeliveryDetailsState,
  (state: DeliveryDetailsState) => state.loading,
);
